<template>
  <div class="page-container">
    <div class="flex mt14 gap200">
      <div class="subFlex gap10">
        <span>跟单本金:</span>
        <el-input
          class="mini"
          placeholder="最小本金"
          clearable
          v-model="objCof.followCapitalMin"
        >
          <template slot="append">USDT</template>
        </el-input>
        <span>-</span>
        <el-input
          class="mini"
          placeholder="最大本金"
          clearable
          v-model="objCof.followCapitalMax"
        >
          <template slot="append">USDT</template>
        </el-input>
      </div>
      <div class="subFlex gap10">
        <span>跟单杠杆:</span>
        <el-input
          placeholder="最小杠杆"
          class="mini"
          clearable
          v-model="objCof.followLeverageMin"
        >
          <template slot="append">X</template>
        </el-input>
        <span>-</span>
        <el-input
          placeholder="最大杠杆"
          class="mini"
          clearable
          v-model="objCof.followLeverageMax"
        >
          <template slot="append">X</template>
        </el-input>
      </div>
    </div>
    <div class="flex mt14 gap200">
      <div class="subFlex gap10">
        <span>跟单比率:</span>
        <el-input
          placeholder="最小比率"
          class="mini"
          clearable
          v-model="objCof.followRatioMin"
        >
          <template slot="append">X</template>
        </el-input>
        <span>-</span>
        <el-input
          placeholder="最大比率"
          class="mini"
          clearable
          v-model="objCof.followRatioMax"
        >
          <template slot="append">X</template>
        </el-input>
      </div>

      <div class="subFlex">
        <span>最大跟随交易员数量:</span>
        <el-input
          class="mini"
          placeholder=""
          clearable
          v-model="objCof.followerThreshold"
        >
        </el-input>
      </div>
    </div>
    <div class="flex mt14 gap200">
      <div class="subFlex gap10">
        <span>初始分享返佣:</span>
        <el-input class="mini" clearable v-model="objCof.initKickbackAmount">
        </el-input>
      </div>

      <div class="subFlex">
        <span>初始带单盈利:</span>
        <el-input
          class="mini"
          placeholder=""
          clearable
          v-model="objCof.initProfitAmount"
        >
        </el-input>
      </div>
    </div>
    <div class="flex mt14 gap200">
      <div class="subFlex gap10">
        <span>初始交易额:</span>
        <el-input class="mini" clearable v-model="objCof.initTradeAmount">
        </el-input>
      </div>

      <div class="subFlex">
        <span>初始化统计值开启开关:</span>
        <el-switch v-model="objCof.initStatEnable"> </el-switch>
      </div>
    </div>
    <div class="flex mt14 gap200">
      <div class="subFlex gap10">
        <span>交易员实名认证等级:</span>
        <el-input class="mini" clearable v-model="objCof.leaderAuthLevel">
        </el-input>
      </div>

      <div class="subFlex">
        <span>交易员合约总权益阈值:</span>
        <el-input class="mini" clearable v-model="objCof.leaderEquityThreshold">
        </el-input>
      </div>
    </div>
    <div class="flex mt14 gap200">
      <div class="flex gap10">
        <span>取消跟单条件：连续跟单失败次数最大值:</span>
        <el-input
          class="mini"
          placeholder=""
          clearable
          v-model="objCof.followFailedCancelThreshold"
        >
        </el-input>
      </div>
      <div class="flex gap10">
        <span>取消跟单条件：跟单价格与带单价格偏离金额:</span>
        <el-input
          class="mini"
          placeholder=""
          clearable
          v-model="objCof.followPriceDeviateThreshold"
        >
        </el-input>
      </div>
    </div>
    <!-- <div class="flex mt14 gap200">
      <div class="subFlex">
        <span>允许跟单模式,分号分隔:</span>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="objCof.allowFollowPositionType"
          size="mini"
        >
        </el-input>
      </div>
      <div class="subFlex">
        <span>用户显示头像:</span>
        <el-input class="mini" placeholder="" clearable v-model="avatar">
        </el-input>
      </div>
    </div> -->

    <div class="flex mt50 center">
      <el-button
        v-if="$hasPerm('tenant:copy_global:save')"
        type="primary"
        @click="submit"
        >保存</el-button
      >
    </div>
    <!-- <div class="mt50">
      <div>交易员标签设置</div>
      <div class="flex gap10">
        <span class="tags"></span>
        <el-button type="primary" @click="addTag">+</el-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import api from "./api";

export default {
  data() {
    return {
      objCof: {
        // allowFollowPositionType: "",
        // avatar: "",
        followCapitalMin: "",
        followCapitalMax: "",
        followFailedCancelThreshold: "",
        followLeverageMax: "",
        followLeverageMin: "",
        followPriceDeviateThreshold: "",
        followRatioMax: "",
        followRatioMin: "",
        followerThreshold: "",
        initKickbackAmount: "",
        initProfitAmount: "",
        initStatEnable: false,
        initTradeAmount: "",
        leaderAuthLevel: "",
        leaderEquityThreshold: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.handleSearch();
  },
  methods: {
    handleSearch() {
      api.copytradeCof().then((res) => {
        if (res.code == 0) {
          this.objCof = res.data;
        }
      });
    },
    submit() {
      // this.objCof.allowFollowPositionType =
      //   this.objCof.allowFollowPositionType.replace(/；/g, ";");
      api.copytradeUpdte(this.objCof).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.handleSearch();
        }
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>

<style scoped lang="less">
.el-textarea {
  width: 300px;
}
.el-input {
  width: 300px;
}
.el-input.mini {
  width: 200px;
}
.flex {
  display: flex;
  align-items: center;
}
.subFlex {
  display: flex;
  width: 45%;
  align-items: center;
  gap: 10px;
}
.mt14 {
  margin-top: 14px;
}
.mt50 {
  margin-top: 50px;
}
.gap200 {
  gap: 200px;
}
.gap10 {
  gap: 10px;
}
.center {
  justify-content: center;
}
</style>
